/** Public, published rankings are locked from edit and delete. */
export function isRankingPublished(ranking) {
  if (!ranking) return false;
  return Boolean(ranking.public) && ranking.draft !== true;
}

export function isRankingEditable(ranking) {
  return !isRankingPublished(ranking);
}

export function isCompetitionEntry(ranking) {
  return Boolean(ranking?.official_ranking_id);
}
